const EMAIL_REGEX =
  /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;

export function validateEmailField(value: string) {
  if (!value) {
    return { isValid: false, errorType: 'required' } as const;
  }

  if (!EMAIL_REGEX.test(value)) {
    return { isValid: false, errorType: 'invalid' } as const;
  }

  return { isValid: true } as const;
}
